import React from 'react'
import './about_section.css'
import about1 from '../images/about1.webp'
import about2 from '../images/about2.webp'

function About_section() {
  return (
    <div className='about-container'>
        <div className="text-container">
            <h1>Who We Are</h1>
            <p><span>C.DG</span> is specialized consultant in design bridges and structures,
                 the firm has wide experience in several projects among the
                  Middle East countries</p>
        </div>
        <div className="image-container">
            <div className="image-stack">
                <div className="image-stack__item image-stack__item--bottom">
                    <img src={about2}/>
                </div>
                <div className="image-stack__item image-stack__item--top">
                    <img src={about1}/>
                </div>
            </div>
        </div>


    </div>
  )
}

export default About_section